import { useEffect } from "react";
import Matter from "matter-js";
import './spoondrop.css';
import {swapDocBody,  useGameState, MAX_HEIGHT, MAX_WIDTH, BACKGROUND_COLOR, cosmeticFilter, createDefined2DVector, spawnParticleBurst, getShipWing, createPlusScore, enemyFilter, getAngleBetweenPos, getExclamationPoint, getLoop, getRandomInt, getSpoon, getSpoonShip, rotatePlayerToward, spoonFilter, createRandom2DVector } from "./util/spoonHelper.js";
import { createMatterEngine } from "./util/createMatterEngine";
import { GameShell } from "./util/GameShell";
import { createPausableTimerGroup } from "./util/pausableTimers";

const SpoonshipAsteroid = () => {
  const gameKey = "spaceOs";
  const flavor = "You are the pilot of a SpoonShip (trademark pending) entering a dangerous astro-cereal field. " ;
  const instructions = "Click or tap to shoot out a spoon and propel yourself forward.";
  const gameState = useGameState(flavor, instructions, gameKey);
  const { canvasRef, setCanvasHeight, restartRef, setPlayButtonText,
    setGameOverState, setMessage, setScoreText, recordScore,
    gameStartedRef, rebuildKey, pauseRef, resumeRef,} = gameState;
  useEffect(() => swapDocBody(), []);
  useEffect( () => {
    var isMobile = false;
    
    const width = Math.min(window.innerWidth, MAX_WIDTH);
    const height = Math.min(window.innerHeight, MAX_HEIGHT);
    setCanvasHeight(height);
    let Bodies = Matter.Bodies;
    let Vector = Matter.Vector;
    let Body = Matter.Body;
    let Composite = Matter.Composite;
    let Mouse = Matter.Mouse;
    let MouseConstraint = Matter.MouseConstraint;
  
    const timers = createPausableTimerGroup();
    const { engine, runner, render, start, cleanup } = createMatterEngine(timers, canvasRef, width, height, {gravity: {y: 0}});

    var gameWidth = width;
    var marginV = height/6;
    var marginH = gameWidth/6;
    var points = 0;
    var size = 50; //size var for spoon
    var maxThrustForce = 0.02;
    var defaultScreenWrapOffset = 50;
    var playerFriction = 0.003;
    var minPowerPercentage = 0.2;
    var powerPercentage = minPowerPercentage;
    var chargeUp = true; 
    var primaryShipColor = "white";
    var secondaryShipColor = "red";
    var fullChargeColor = "#f14ae3ff"
    var chargeThreshold1 = 0.5;
    var chargeThreshold2 = 0.85;
    var chargeIncrement = 0.01;
    var boundaryLabel = "bounds";
    var deathCosmetics = [];
    // const blackHoleLabel = "blackHole"
    var enemyInterval = null;
    var captureHole = null;
    var needProjectileOOBCheck = false;
    // var holeOn = false; //debug
    const blackHoleDefaultTimeout = 15;
    //mobile augmentations
    if(width < 900){
      isMobile = true;
      size = width > 500 && height > 500 ? 40 : 30;
      maxThrustForce = size/6000;
    }
    let playerScreenWrapOffset = size/2;
    if(isMobile){
      setScoreText("On mobile, locking screen orientation and playing horizontally is recommended.");
    }
    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0,
          render: {
            visible: false
          },
          isSensor: true
        }
      });
      // --- Keyboard handling lives here too ---
    function handleKey(e) {
      //debug stuff
      if (e.code === "Space") {
        // spawnAsteroid();
        // if(holeOn){
        //   eraseBlackHoles();
        //   // holeOn = false;
        // }
        // else{
          // summonBlackHole();
          // holeOn = true;
        // }
      }
    }

    window.addEventListener("keydown", handleKey);

    function createBoundingBox(){
      Composite.add(engine.world, [
        // walls
        Bodies.rectangle(width/2, height+size, width*2, size*2, { 
         isSensor: true, isStatic: true, collisionFilter:enemyFilter, label: boundaryLabel}),
        Bodies.rectangle(width/2, -size, width*2, size*2, { 
         isSensor: true, isStatic: true, collisionFilter:enemyFilter, label: boundaryLabel}),
        Bodies.rectangle(-size, height/2, size*2, height*2, { 
         isSensor: true, isStatic: true, collisionFilter:enemyFilter, label: boundaryLabel}),
        Bodies.rectangle(width+size, 0, size*2, height*2, { 
         isSensor: true, isStatic: true, collisionFilter:enemyFilter, label: boundaryLabel})
      ]);
    }
    createBoundingBox();
    Composite.add(engine.world, mouseConstraint);
    let playerShip = getSpoonShip(size, width/2, height/2, spoonFilter, primaryShipColor, secondaryShipColor)
    playerShip.frictionAir = playerFriction;
    Composite.add(engine.world, playerShip);
    let playerCaptureTimer = 0;
    const captureTime = 1000; // ms player must stay inside to be captured
    let playerCaptured = false;
    var gameStarted = false;
    var resettable = false;
    var isCharging = false;
    var projectiles = [];
    var asteroids = [];
    Matter.Events.on(mouseConstraint, "mousedown", function(event) {
      isCharging = true;
    });

    Matter.Events.on(mouseConstraint, "mouseup", function(event){
      isCharging = false;
      applyThrust();
      // asteroids.forEach(asteroid => {
      //   explodeAsteroid(asteroid);
      // });
    });
    Matter.Events.on(engine, "beforeUpdate", (evt) => {
      const dt = evt.delta;  // ms between frames
      const target = mouse.position;
      chargeShot();
      activeBlackHoles.forEach(hole => {
        gravitationalPull(hole);
        doCaptureLogic(hole, dt)
      });
      if(captureHole){
        stickToHole(captureHole.body);
      }
      else if (playerCaptured){
        releasePlayer()
      }
      if(!isMobile || (isMobile && isCharging)){
        rotatePlayerToward(target, dt, playerShip, false, true);
      }
      
    });
    Matter.Events.on(engine, "afterUpdate", (evt) => {
      if(gameStarted){
        redrawPlayer();
      }
      offScreenCheck(playerShip, playerScreenWrapOffset);
      if(needProjectileOOBCheck){
        offScreenCheckProjectiles();
      }
      offScreenCheckAsteroids();
    });
    
    Matter.Events.on(engine, "collisionStart", function(event) {
      event.pairs.forEach(pair => {
        collisionLogic(pair, true);
      });
    });
    Matter.Events.on(engine, "collisionEnd", function(event) {
      event.pairs.forEach(pair => {
        collisionLogic(pair, false);
      });
    });
    function collisionLogic(pair, isStart){
      var { bodyA, bodyB } = pair;
      bodyA = bodyA.parent;
      bodyB = bodyB.parent;
      if(bodyA.label.includes("bounds")){ boundaryCheck(bodyA, bodyB, isStart)}
      else if(bodyB.label.includes("bounds")){ boundaryCheck(bodyB, bodyA, isStart)}
      else if(!isStart){return;}
      //TODO Asteroid hit by projectile code. make unique identifiers for asteroids that will be given to it's children so that one asteroid can only be
      if(bodyA.label.includes("asteroid")){ hitAsteroid(bodyA, bodyB)}
      else if(bodyB.label.includes("asteroid")){ hitAsteroid(bodyB, bodyA)}
      //hit by a single shot once 
    }
    function boundaryCheck(bounds, otherBody, isStart){
      //projectile met bounds so we check if it can wrap or destroy it
      projectiles.forEach( p => {
        if(p.body && p.body === otherBody.parent){
          if(p.isLive === true && isStart){
            p.isOOB = true;
            needProjectileOOBCheck = true;
          }
          if(p.isLive && !isStart){
            //projectile is coming back into gameview
            p.isOOB = false;
          }
        }
      });
      //may need to do same for asteroids
    }

    function hitAsteroid(asteroid, otherBody){
      if(otherBody.parent === playerShip){
        if(gameStarted){
          gameOver();
        }
        explodeAsteroid(asteroid)

      }
      Composite.allBodies(engine.world)
        .forEach(body => {
          if (otherBody.parent === body && body.label.includes("projectile") ) {
            if(checkIfVulnerable(asteroid, otherBody)){
              for(let i = projectiles.length-1; i >= 0; i--){
                let p = projectiles[i];
                if(p.body && p.body === otherBody.parent && !p.onCooldown){
                  p.onCooldown = true;
                  asteroid.hasBeenHit = true;
                  p.bufferedSpeed = {
                    x: p.body.velocity.x,
                    y: p.body.velocity.y
                  };
                  Body.setVelocity(p.body, {x:0, y:0})
                  p.cooldownTimeOut = timers.setTimeout(() => {
                    if (projectiles.includes(p)) {
                      p.onCooldown = false;
                      Body.setVelocity(p.body, p.bufferedSpeed)
                    }
                  }, 50)
                  doPointIncrement(p, asteroid.position);
                  explodeAsteroid(asteroid, p.asteroidHits);
                  demoteProjectile(p)
                }
              }
            }
          }
        });
    }
    function checkIfVulnerable(asteroid){
      let vulnerable = !asteroid.hasBeenHit;
      
      return vulnerable;
    }
    function checkPlayerInHole(player, holeObject) {
      let holeBody = holeObject.body;
      const dx = player.position.x - holeBody.position.x;
      const dy = player.position.y - holeBody.position.y;
      const dist = Math.sqrt(dx*dx + dy*dy);

      const pullRadius = holeBody.circleRadius * 3; // tune as needed

      return dist < pullRadius;
    }
    function doCaptureLogic(holeObject, dt){
      const inHole = checkPlayerInHole(playerShip, holeObject);
      //reset hole shrink
      
      if (!playerCaptured) {
        if (inHole) {
          playerCaptureTimer += dt;

          if (playerCaptureTimer >= captureTime) {
            capturePlayer(playerShip, holeObject);
          }
        } else {
          playerCaptureTimer = 0; // reset if they leave
        }
      }
    }
    
    function capturePlayer(player, holeObject) {
      playerCaptured = true;
      Body.setVelocity(player, { x: 0, y: 0 });
      captureHole = holeObject;
      if(holeObject.shrinking){
        resetShrinkCosmetics(holeObject);
      }
    }

    function stickToHole(holeBody) {
      if (playerCaptured) {
        const dx = holeBody.position.x - playerShip.position.x;
        const dy = holeBody.position.y - playerShip.position.y;
        Body.translate(playerShip, {x: dx,y: dy})
      }
    }
    function releasePlayer() {
      playerCaptured = false;
      playerCaptureTimer = 0;
    }
    function deathAnimation(player){
      Body.setVelocity(player, {x:0, y:0})
      Composite.remove(engine.world, player)
      let rightWing = getShipWing(player.position.x, player.position.y, size, false);
      let leftWing = getShipWing(player.position.x, player.position.y, size, true);
      deathCosmetics.push(rightWing);
      deathCosmetics.push(leftWing);
      spawnCrumbBurst(player, primaryShipColor);
      spawnCrumbBurst(player, primaryShipColor);
      spawnCrumbBurst(player, secondaryShipColor);
      Composite.add(engine.world, [rightWing, leftWing])
      Body.applyForce(leftWing, leftWing.position, createRandom2DVector(.0005))
      Body.applyForce(rightWing, rightWing.position, createRandom2DVector(.0005))
      Body.setAngularSpeed(leftWing, .5 + Math.random()/2)
      Body.setAngularSpeed(rightWing, .5 + Math.random()/2)
    }

    function spawnCrumbBurst(body, color = null){
      spawnParticleBurst(timers, body, color, isMobile, engine, Composite);
    }

    //returns true if projectile is destroyed
    function demoteProjectile(p){
      let destroyed = false;
      if(p.pierceLeft > 0){
        p.pierceLeft = p.pierceLeft - 1;
      }
      else{
        destroyProjectile(p);
        destroyed = true;
      }
      return destroyed;
    }

    function destroyProjectile(p){
      Composite.remove(engine.world, p.body);
      if(p.deleteTimeout){
        timers.clearTimeout(p.deleteTimeout);
      }
      const idx = projectiles.indexOf(p);
      if(idx !== -1){
        projectiles.splice(idx, 1);
      }
    }
    function applyThrust(){
      if(!playerCaptured){
        spaceForce(playerShip, false)
      }
      shootSpoon(playerShip.angle);
    }
    function shootSpoon(angle, shotSize = size/6){
      shotSize = powerPercentage < chargeThreshold1 ? size/4 : powerPercentage < chargeThreshold2 ? size/3 : size/2
      let shotCharge = powerPercentage < chargeThreshold1 ? "NoCharge" : powerPercentage < chargeThreshold2 ? "HalfCharge" : "FullCharge"
      let color = powerPercentage > chargeThreshold2 ? fullChargeColor : secondaryShipColor
      let shotSpoon = getSpoon(shotSize, playerShip.position.x, playerShip.position.y, spoonFilter, color);
      shotSpoon.label = "projectile" + shotCharge;
      shotSpoon.frictionAir = 0;
      Body.setAngle(shotSpoon, angle + Math.PI);
      Matter.Composite.add(engine.world, shotSpoon);
      Body.setAngularVelocity(shotSpoon, 0);
      Body.setAngularSpeed(shotSpoon, 0);
      let projectile = createProjectile(shotSpoon, shotCharge);
      projectile.angle = angle + Math.PI;
      spaceForce(shotSpoon, true, projectile.escapeBoosted);
      resetCharge();
    }
    function createProjectile(body, charge){
      let loopsLeft = charge === "FullCharge" ? 1 : 0;
      let pierceLeft = !(charge === "NoCharge") ? 2 : 0;
      if(charge === "HalfCharge"){
        pierceLeft = 1;
      }
      let projectile = {
        body: body,
        charge: charge,
        loopsLeft: loopsLeft,
        pierceLeft: pierceLeft,
        deletable: false,
        isLive: true,
        isOOB: false,
        escapeBoosted: playerCaptured,
        deleteTimeout: null,
        asteroidHits: 0,
        onCooldown: false,
        cooldownTimeOut: null,
        bufferedSpeed: 0
      };
      let lifetime = charge === "NoCharge" ? isMobile ? 750 : 1000 : 10000
      projectile.deleteTimeout = timers.setTimeout(() => {
        destroyProjectile(projectile);
      }, lifetime);
      projectiles.push(projectile);
      return projectile;
    }
    function resetCharge(){
      powerPercentage = minPowerPercentage;
      visualizeCharge();
    }
    function chargeShot(){
      if(isCharging){
        if(chargeUp){
          if(powerPercentage < 1){
            powerPercentage += chargeIncrement;
          }
          //No longer goes back down
        //   else{
        //     chargeUp = false;
        //   }
        }
        // if(!chargeUp){
        //   if(powerPercentage > minPowerPercentage){
        //     powerPercentage -= chargeIncrement;
        //   }
        //   else{
        //     chargeUp = true;
        //   }
        // }
        visualizeCharge();
      }
    }

    function visualizeCharge() {
      const thresholds = {
        c1: [minPowerPercentage, secondaryShipColor],
        c2: [chargeThreshold1, secondaryShipColor],
        c3: [chargeThreshold2, fullChargeColor]
      };

      playerShip.parts.forEach(p => {
        if (thresholds[p.label]) {
          const [limit, color] = thresholds[p.label];
          p.render.fillStyle =
            powerPercentage > limit ? color : primaryShipColor;
        }
      });
    }

    function spaceForce(body, isThruster, escapeBoosted = false){
      let angle = body.angle;
      let force = isThruster ? maxThrustForce/2 : maxThrustForce;
      force = escapeBoosted ? force/2 : force;
      force *= powerPercentage;
      Body.applyForce(body, body.position, createDefined2DVector(force, angle));
    }
    function redrawPlayer(){
      Composite.remove(engine.world, playerShip);
      Composite.add(engine.world, playerShip);
    }
    function screenWrapX(body, screenWrapOffset){
      let y = body.position.y;
      let offset = screenWrapOffset - 1;
      let wrapTo = body.position.x < 0 ? width + offset : -offset;
      Composite.remove(engine.world, body);
      Body.setPosition(body, Vector.create(wrapTo, y));
      Composite.add(engine.world, body); 
    }
    function screenWrapY(body, screenWrapOffset){
      let x = body.position.x;
      let offset = screenWrapOffset - 1;
      let wrapTo = body.position.y < 0 ? height + offset : -offset;
      Composite.remove(engine.world, body);
      Body.setPosition(body, Vector.create(x, wrapTo));
      Composite.add(engine.world, body); 
    }
    function offScreenCheck(body, screenWrapOffset){
      let y = body.position.y;
      let x = body.position.x;
      if(y < -screenWrapOffset || y > height + screenWrapOffset){
        screenWrapY(body, screenWrapOffset);
      }
      if(x < -screenWrapOffset || x > width + screenWrapOffset){
        screenWrapX(body, screenWrapOffset);
      }
    }
    function offScreenCheckAsteroids(){
      for(let i = 0; i < asteroids.length; i++){
        let a = asteroids[i];
        let mobileMod = isMobile ? .5 : 1;
        offScreenCheck(a, mobileMod*defaultScreenWrapOffset/(4-a.level));
      }
    }
    //handles all projectile deletes via p.deletable
    //hands off to screenwrap function
    function offScreenCheckProjectiles(){
      let checkStillNeeded = false;
      for (let i = projectiles.length - 1; i >= 0; i--) {
        const p = projectiles[i];
        if(p.deletable){
          destroyProjectile(p);
        }
        else if(p.isOOB){
          checkStillNeeded = true;
          if(offScreenCheckProjectile(p, defaultScreenWrapOffset/4)){
            destroyProjectile(p);
          }
        }
      }
      needProjectileOOBCheck = checkStillNeeded;
    }
    //returns true if wrap happened
    function offScreenCheckProjectile(projectile, screenWrapOffset){
      let body = projectile.body;
      let y = body.position.y;
      let x = body.position.x;
      let needsDelete = false;
      if(y < -screenWrapOffset || y > height + screenWrapOffset){
        if(projectile.loopsLeft > 0){
          screenWrapY(body, screenWrapOffset);
          projectile.loopsLeft -= 1;
        }
        else{needsDelete = true;}
      }
      if(x < -screenWrapOffset || x > width + screenWrapOffset){
        if(projectile.loopsLeft > 0){
          screenWrapX(body, screenWrapOffset);
          projectile.loopsLeft -= 1;
        }
        else{needsDelete = true;}
      }
      return needsDelete;
    }
    var activeBlackHoles = [];
    var pendingBlackHoles = [];
    function clearPendingBlackHoles(){
      pendingBlackHoles.forEach(ph => {
        Composite.remove(engine.world, ph.body);
        timers.clearTimeout(ph.timeout);
        timers.clearInterval(ph.flashInterval)
      });
    }

    function summonBlackHole(){
      let warningTime = 2000
      let x = Math.random()*(width-2*marginH)+marginH;
      let y = Math.random()*(height-2*marginV)+marginV;
      // warning
      let warningBody = getExclamationPoint(x, y, size/4);
      let warningObject = {body: warningBody, timeout: null, flashInterval: null, hidden: false}
      Composite.add(engine.world, warningBody);
      warningObject.flashInterval = timers.setInterval(() => {
        if(warningObject.hidden){
          Composite.add(engine.world, warningBody);
          warningObject.hidden = false;
        }
        else{
          Composite.remove(engine.world, warningBody);
          warningObject.hidden = true;
        }
      }, 300);
      warningObject.timeout = timers.setTimeout(() => {
        pendingBlackHoles.splice(0, 1);
        timers.clearInterval(warningObject.flashInterval);
        Composite.remove(engine.world, warningBody);
        createHoleObject(x, y);
      }, warningTime);
      pendingBlackHoles.push(warningObject);
    }
    function createHoleObject(x, y){
      let col = {category: 0x0002, group: 1}
      let holeBody = Bodies.circle(x, y, size/2, 
        {isSensor: true, render:{fillStyle: BACKGROUND_COLOR}, density: 10, label: "blackHole", collisionFilter: col});
      let holeOutline = Bodies.circle(x, y, size/2 + size/16, 
        {isSensor: true, render:{fillStyle: "white"}});
      let shrinker = Bodies.circle(x, y, size/2, 
        {isSensor: true, render:{fillStyle: "black"}});
      let holeObject = {body: holeBody, outline: holeOutline, shrinkBody: shrinker, particleSpawn: null, 
        lifeTimer: blackHoleDefaultTimeout, deleteInterval: null, captureReset: false, shrinking: false, shrinkInterval: null, shrinkTracker: Math.PI/2};
      holeObject.deleteInterval = timers.setInterval(() => {
        // console.log("hole life: " + holeObject.lifeTimer)
        if(captureHole === holeObject && !holeObject.captureReset){
          holeObject.captureReset = true;
          holeObject.lifeTimer = blackHoleDefaultTimeout;
        }
        if(holeObject.lifeTimer > 0){
          if(holeObject.lifeTimer === 1){
            shrinkHole(holeObject);
          }
          holeObject.lifeTimer -= 1;
        }
        else{
          timers.clearInterval(holeObject.deleteInterval);
          blackHoleTimeout(holeObject);
        }
      }, 1000);
      holeBody.holeObject = holeObject;
      activeBlackHoles.push(holeObject);
      Composite.add(engine.world, holeObject.body);
      Composite.add(engine.world, holeObject.outline);
      Composite.add(engine.world, shrinker);
      holeObject.particleSpawn = timers.setInterval(() => {
        spawnGravParticles(x, y);
      }, 100);
    }

    function shrinkHole(h){
      // h.cover.render.fillStyle = "white";
      let interval = 10;
      h.shrinking = true;
      h.shrinkInterval = timers.setInterval(() => {
      let newSize = Math.abs(Math.sin(h.shrinkTracker)*size);
      let scale = newSize/size;
      h.shrinkTracker += Math.PI/(10000/interval)
      Body.scale(h.shrinkBody, scale, scale);
      Body.scale(h.outline, scale, scale);
      }, interval);
    }

    function resetShrinkCosmetics(holeObject){
      // holeObject.cover.render.fillStyle = "#FFFFFF00"
      holeObject.shrinking = false;
      timers.clearInterval(holeObject.shrinkInterval);
      Composite.remove(engine.world, holeObject.shrinkBody);
      Composite.remove(engine.world, holeObject.outline);
      let shrinker = Bodies.circle(holeObject.body.position.x, holeObject.body.position.y, size/2, 
        {isSensor: true, render:{fillStyle: "black"}});
      let holeOutline = Bodies.circle(holeObject.body.position.x, holeObject.body.position.y, size/2 + size/16, 
        {isSensor: true, render:{fillStyle: "white"}});
      holeObject.shrinkBody = shrinker;
      holeObject.outline = holeOutline;
      Composite.add(engine.world, holeObject.outline);
      Composite.add(engine.world, holeObject.shrinkBody);
    }

    function eraseBlackHole(h){
      Composite.remove(engine.world, h.body);
      Composite.remove(engine.world, h.outline);
      Composite.remove(engine.world, h.shrinkBody);
      timers.clearInterval(h.particleSpawn);
      timers.clearInterval(h.shrinkInterval);
    }
    //clears all black holes
    function eraseBlackHoles(){
      activeBlackHoles.forEach(h => {
        eraseBlackHole(h);
        if(h.deleteInterval){
          timers.clearInterval(h.deleteInterval)
        }
      });
      activeBlackHoles.splice(0, activeBlackHoles.length);
      captureHole = null;
      clearPendingBlackHoles();
    }
    //clears single black hole
    function blackHoleTimeout(holeObject){
      eraseBlackHole(holeObject);
      activeBlackHoles.splice(activeBlackHoles.indexOf(holeObject), 1);
      if(holeObject === captureHole){
        captureHole = null;
        releasePlayer();
      }
    }
    function gravitationalPull(holeObject) {
      if(!playerCaptured){
        doGravity(holeObject.body, playerShip, 0.0003);
      }
      projectiles.forEach(p => {
        if(p.body && !p.escapeBoosted){
          doGravity(holeObject.body, p.body)
        }
      });
      let g = playerCaptured ? 0.0002 : 0.0005
      asteroids.forEach(a => {if(a.isActive){doGravity(holeObject.body, a, g)}});
    }
    function doGravity(holeBody, body, G = 0.0005){
      const dx = holeBody.position.x - body.position.x;
      const dy = holeBody.position.y - body.position.y;

      const distSq = dx * dx + dy * dy;
      let dist = Math.sqrt(distSq);
      
      // Prevent divide-by-zero or infinite accelerations
      const minDist = size; 
      if (dist < minDist) return;
      

      // Force magnitude
      const forceMag = G * (body.mass * holeBody.mass) / distSq;
      
      // Normalize direction
      const fx = (dx / dist) * forceMag;
      const fy = (dy / dist) * forceMag;

      Body.applyForce(body, body.position, { x: fx, y: fy });
    }

    function spawnGravParticles(x, y, count = 1) {
      for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        let baseSpeed = 1.5;
        const speed = isMobile ? (baseSpeed/2 + Math.random() * baseSpeed/2) : (baseSpeed + Math.random() * baseSpeed);
        let radius  = isMobile ? 1.5 : 2
        let spawnDistance = isMobile ? 25 + 5*Math.random() : 50 + 10*Math.random() 
        const particle = Matter.Bodies.circle(x + Math.cos(angle)*spawnDistance, 
          y + Math.sin(angle)*spawnDistance, radius, {
            isSensor: true,
            restitution: 0.6,
            friction: 0.05,
            render: { fillStyle: "white" }
          });

        Matter.Body.setVelocity(particle, {
          x: -1 * Math.cos(angle) * speed,
          y: -1 * (Math.sin(angle) * speed) 
        });

        Composite.add(engine.world, particle);

        // Auto-remove after a short time
        timers.setTimeout(() => Composite.remove(engine.world, particle), 250);
      }
    }
    function spawnAsteroid(){
      let side = getRandomInt(4);
      let x;
      let y;
      let mult = Math.random()/10
      if(side % 2 === 0) {// top or bottom
        x = gameWidth*Math.random();
        y = mult*height
        if(side > 0){
          y = height - height*mult
        }
      }
      else {//sides
        y = height*Math.random();
        x = mult*gameWidth;
        if(side > 1){
          x = gameWidth - mult*gameWidth
        }
      }
      let asteroid = getLoop(x, y, cosmeticFilter, size, 0, 1, true, false, true, null, "asteroid");
      
      asteroid.level = 3;
      asteroid.isActive = false;
      let fadeCover = Bodies.circle(x, y, size, {
        collisionFilter: cosmeticFilter,
        isSensor: true,
        isStatic: true,
        render: {fillStyle: BACKGROUND_COLOR, opacity: 1}
      }) 
      Composite.add(engine.world, asteroid);
      Composite.add(engine.world, fadeCover);
      asteroids.push(asteroid);
      let fadeInterval = timers.setInterval(() => {
        let op = fadeCover.render.opacity;
        if(op <= 1/30){
          Composite.remove(engine.world, fadeCover);
          if(asteroid){
            pushAsteroid(asteroid);
            asteroid.isActive = true;
          }
          timers.clearInterval(fadeInterval);
        }
        else{
          op -= 1/30;
          fadeCover.render.opacity = op;
        }
        if(op <= 2/30){
          asteroid.collisionFilter = enemyFilter;
        }
      }, 100)
    }
    function spawnAsteroidChild(asteroid, moveAngle){
      let childSize = asteroid.level > 2 ? size*2/3 : size/3;
      let child  = getLoop(asteroid.position.x, asteroid.position.y, enemyFilter, childSize, 0.01, 1, false, false, true, asteroid.color, "asteroid");
      child.level = asteroid.level - 1;
      child.isActive = true;
      Composite.add(engine.world, child);
      asteroids.push(child);
      timers.setTimeout(() => {
        if(child){
          child.frictionAir = 0;
        }
      },200*(3-child.level));
      pushAsteroid(child, moveAngle);
    }

    function pushAsteroid(asteroid, moveAngle = null){
      if(moveAngle === null){
        let destination = getAsteroidDestination();
        moveAngle = getAngleBetweenPos(destination, asteroid.position)-Math.PI/2;
        asteroid.angle = moveAngle;
      }
      else{
        asteroid.angle = moveAngle;
      }
      let baseForce = isMobile ? 3 : 10;
      baseForce *= asteroid.level; 
      let force = baseForce + baseForce*Math.random()
      Body.applyForce(asteroid, asteroid.position, createDefined2DVector(force, moveAngle));
    }

    function getAsteroidDestination()
    {
      let possibleW = 1/3*width;
      let possibleH = 1/3*height;
      let marginX = (width-possibleW)/2
      let marginY = (height-possibleH)/2
      let destinationPos = {x: marginX + possibleW*Math.random(), y: marginY + possibleH*Math.random()};
      return destinationPos;
    }

    function explodeAsteroid(asteroid, crumbBursts = 1){
      let childCount = 0;
      for(let i = 0; i < crumbBursts; i++){
        spawnCrumbBurst(asteroid)
      }
      Composite.remove(engine.world, asteroid);
      asteroids.splice(asteroids.indexOf(asteroid), 1);
      if(gameStarted){
        if(asteroid.level > 1){
          childCount = 1 + getRandomInt(3);
        }
        for(let i = 0; i < childCount; i++){
          let angleSelector = getRandomInt(4)
          let angle = angleSelector > 0 ? asteroid.angle + Math.random()*Math.PI*2/3 - Math.PI/3 : Math.random()*Math.PI*2;
          spawnAsteroidChild(asteroid, angle);
        }
      }
    }

    

    function startEnemy(){
      let round = 1;
      let roundGroupTracker = 1;
      let roundGroupAmount = 4;
      let asteroidsLeft = 0;
      let baseRoundTimer = 30;
      let roundTimer = baseRoundTimer;
      let startPoint = 3;
      enemyInterval = timers.setInterval(() => {
        asteroidsLeft = 0;
        asteroids.forEach(asteroid => {
          let level = asteroid.level;
          let val = level === 3 ? 5 : level === 2 ? 3 : 1;
          asteroidsLeft+= val;
        });
        let spawnHoldPoint = roundGroupTracker%roundGroupAmount === 0;
        if(asteroids.length === 0 || 
          ((roundTimer <= 0 && !spawnHoldPoint) ||
          (spawnHoldPoint && asteroidsLeft < startPoint))){
          //reset and enlarge spawnHoldPoint factors
          if(spawnHoldPoint){
            roundGroupTracker = 1;
            roundGroupAmount++;
            startPoint+=3;
          }
          for (let i = getRandomInt(3) + 1; i > 0; i--){
            spawnAsteroid()
          }
          round++;
          let roundTimeModifier = Math.floor(round/2);
          roundTimer = baseRoundTimer - roundTimeModifier;
          if(roundTimer < 20) { roundTimer = 20}
        }
        if(getRandomInt(60) === 0){
          summonBlackHole();
        }
        roundTimer--;
      }, 1000)
    }
    
    function startGame() {
      if (gameStarted === false) {
        setGameOverState(false); // Show game over screen
        gameStarted = true;
        gameStartedRef.current = true;
        startEnemy();
        setText();
      }
    }
    function restartGame(){
      if (resettable === true){
        //cleanup and reset
        let playerRemoved = true;
        Composite.allBodies(engine.world)
          .forEach(body => {
            if (body.label === "asteroid") {
              Composite.remove(engine.world, body);
            }
            if (body.label === "spoonShip") {
              playerRemoved = false;
            }
          });
        if(playerRemoved){
          Composite.add(engine.world, playerShip)
        }
        Body.setVelocity(playerShip, { x: 0, y: 0 });
        Body.setAngularVelocity(playerShip, 0);
        Body.setPosition(playerShip, { x: width/2, y: height/2 });   
        asteroids.splice(0, asteroids.length);
        projectiles.forEach(projectile => {
          Composite.remove(engine.world, projectile);
        })
        projectiles.splice(0, projectiles.length);
        eraseBlackHoles()
        deathCosmetics.forEach(c => {
          Composite.remove(engine.world, c);  
        })
        deathCosmetics.splice(0, deathCosmetics.length)
        resettable = false
        points = 0;
        setScoreText(0 + " points");            // reset score
        setMessage("")
        startGame();
      }
    }
    function gameOver() {
      recordScore(points);
      deathAnimation(playerShip)
      setScoreText("Score: " + points + " points");
      let endMessage = getPopupMessage()
      setMessage(endMessage)        
      gameStarted = false;
      gameStartedRef.current = false;
      resettable = true;
      releasePlayer()
      setText()
      //leaderboards
      timers.clearInterval(enemyInterval);
      timers.setTimeout(() => {
        setGameOverState(true); // Show game over screen
      }, 1100)
    }

    function doPointIncrement(projectile, asteroidPos) {
      projectile.asteroidHits += 1
      points+= 100*(projectile.asteroidHits);
      let mutlihitOffset = projectile.asteroidHits*size*0.8
      let color = "#FFFFFF"
        if(projectile.asteroidHits > 1){
          color = "#3df13d"
        }
        if(projectile.asteroidHits > 2){
          color = "rainbow"
        }
        let posX = asteroidPos.x + mutlihitOffset;
        let posY = asteroidPos.y - mutlihitOffset;
        if(posX > width - size){posX = width - size}
        if(posY < size){posY = size}
      createPlusScore(timers, posX, posY, projectile.asteroidHits*100, engine.world, true, color, isMobile)
      setText()
    }
    function setText() {
      const dropperEl = document.getElementById("dropper");
      const tutEl = document.getElementById("descenttut");
      //point tracking messages
      if(!gameStarted){
        if (dropperEl) dropperEl.innerHTML = "";
        if (tutEl) tutEl.innerHTML = ""
      }
      else if(points >= 10000){
        if (dropperEl) dropperEl.innerHTML = "Whoa! " + points + " points";
      }
      else if(points >= 2000){
        if (dropperEl) dropperEl.innerHTML = "Nice! " + points + " points"; 
      }
      else if(points === 0){
        if (dropperEl) dropperEl.innerHTML = "Tap to shoot, hold to charge a more powerful shot."
        if (tutEl) tutEl.innerHTML = ""
      }
      else{
        if (dropperEl) dropperEl.innerHTML = points + " points";
        if (tutEl) tutEl.innerHTML = ""
      }
      //if (dropperEl && debug) dropperEl.innerHTML = "Whoa! " + points + " points. Speed = " + speed;
    }
    function getPopupMessage(){
      
      let message;
      if(points >= 100000){
        message = "Always shoot for the Moon. Even if you miss you'll end up among the stars. Did I say moon? I meant spoon."
      }
      else if(points >= 20000){
        message = "Wow you really ate that cereal for breakfast!";
      }
      else if(points >= 6900){
        message = "Not too bad pilot. You turned those O's into Exes (explosions)";
      }
      else message = "O nO! The ship has been cOmprOmised...";
      return message;
    }
      
    function startRestart(){
      if(!gameStarted && !resettable){startGame()}
      else{
        restartGame();
      }
      setPlayButtonText("Restart")
    }
    restartRef.current = startRestart;
    pauseRef.current = () => {
      runner.enabled = false;
      timers.pauseAll();
      setScoreText("Score: " + points + " points")
    };
    resumeRef.current = () => {
      runner.enabled = true;
      timers.resumeAll();
    };

    start();
    setGameOverState(true); // Show game over screen
  // Cleanup on unmount
    return () => {
      cleanup()
      window.removeEventListener("keydown", handleKey);
      clearPendingBlackHoles();
      eraseBlackHoles();
      
    };
  }, [canvasRef, restartRef, setCanvasHeight, setGameOverState, setMessage, setPlayButtonText, setScoreText, recordScore, gameStartedRef, rebuildKey, pauseRef, resumeRef]);



  
  return (
    <GameShell gameName="Space O's" canvasRef={canvasRef} gameState={gameState} />
  )
  
  
};

export default SpoonshipAsteroid;